module.exports = __webpack_public_path__ + "static/media/4playerRoomsPlayed_50000_75000.9e3c850b.png";